import { render, staticRenderFns } from "./DepartmentManagementListItem.vue?vue&type=template&id=3ecfd93d"
import script from "./DepartmentManagementListItem.vue?vue&type=script&lang=js"
export * from "./DepartmentManagementListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports